<script>
    import { run, preventDefault, handlers } from "svelte/legacy";

    import { createEventDispatcher, onMount, tick } from "svelte";
    import * as customService from "./v2-service.js";
    import { notificate } from "../../../services/notification.js";
    import { flatten422Errors } from "../../../services/api.svelte.js";
    import { translateErrorMessages } from "../../../services/api.svelte.js";
    import { form as svForm, field } from "svelte-forms";
    import { required } from "svelte-forms/validators";
    import References from "./_components/_references.svelte";
    import vulnerabilityService from "../service.js";
    import VulnerabilityAPI from "../vulnerabilities.api.js";
    import { format } from "svelte-i18n";

    const dispatch = createEventDispatcher();

    let {
        formData = $bindable({}),
        config = { edit: true },
        references = $bindable([""]),
        onsave,
        oncancel,
    } = $props();

    const md = new window.markdownit({ html: false });

    let markdown_es = $state();
    let markdown_en = $state();
    let result_es = $state({ data: null });
    let result_en = $state({ data: null });
    let showSubmit = $state(true);

    const CVSS_v3_items = vulnerabilityService.getCVSSv3items();

    let formIsSubmitted = false;
    let APIerror = null;
    let formApiErrors = {};
    let showCalculator = $state(false);
    let is_builder_enabled = $state({ data: false });
    let has_data = $state(formData.cvss3_vector ? true : false);
    let invalid_refs = $state([]);
    let references_is_empty = $state(false);
    let cwe = $state();
    let loading_cwe = $state(false);
    let cwe_not_validated_error = $state(null);

    let selected_cvss_items = $state({
        AV: "",
        AC: "",
        PR: "",
        UI: "",
        S: "",
        C: "",
        I: "",
        A: "",
    });

    const clearSelectedValues = () => {
        selected_cvss_items = {
            AV: "",
            AC: "",
            PR: "",
            UI: "",
            S: "",
            C: "",
            I: "",
            A: "",
        };
        formData.cvss3_vector = null;
        formData.cvss3_vectorScore = 0;
    };

    const myForm = svForm();

    const addReferenceInput = () => {
        references = [...references, ""];
    };

    const removeReferenceInput = (event) => {
        let i = event.detail;
        references.splice(i, 1);
        references = [...references];
    };

    const pushReferences = (refs) => {
        formData.references = refs;
    };

    const url_isValid = (str) => {
        try {
            new URL(str);
            return true;
        } catch (error) {
            return false;
        }
    };

    const showCWE = () => {
        loading_cwe = true;
        let value = formData.cwe_id;
        VulnerabilityAPI.findCWE(value)
            .then((pCwe) => (cwe = pCwe))
            .catch((e) => (cwe = "CWE no encontrado."));
        cwe = cwe;
        return (loading_cwe = false);
    };

    function handleSubmit(config = {}) {
        showSubmit = false;
        invalid_refs = [];
        references_is_empty = false;

        formIsSubmitted = true;
        formApiErrors = {};

        if (cwe == "CWE no encontrado.") $myForm.valid = false;
        if (!cwe && formData.cwe_id)
            return (cwe_not_validated_error =
                "Por favor, valide el id de CWE o deje el campo en blanco.");

        if (!$myForm.valid) {
            notificate("422");
            showSubmit = true;
            return false;
        }

        if (formData.cwe_id == "") formData.cwe_id = null;
        if (formData.cvss3_vector == "") formData.cvss3_vector = null;

        formData.references = formData.references || [];

        for (let ref of formData.references) {
            if (!url_isValid(ref)) invalid_refs.push(ref);
        }

        if (invalid_refs.length) {
            showSubmit = true;
            return (invalid_refs = invalid_refs);
        }

        if (!formData.references.length) {
            showSubmit = true;
            return (references_is_empty = true);
        }

        formData.summary_es = markdown_es;
        formData.summary = markdown_en;

        customService
            .save(formData, [], config)
            .then((savedCustomVul) => {
                if (config.add) {
                    formData.id = savedCustomVul.id;

                    return customService
                        .save(formData)
                        .then((editedCustomVul) => {
                            dispatch("save", { editedCustomVul });
                            formData = {};
                            formIsSubmitted = false;
                            formApiErrors = {};
                            cwe = null;
                            showSubmit = true;
                            return true;
                        });
                } else {
                    formData = {};
                    formIsSubmitted = false;
                    formApiErrors = {};
                    APIerror = null;
                    dispatch("save");
                    cwe = null;
                    showSubmit = true;
                    return true;
                }
            })
            .catch((errors) => {
                if (typeof errors.detail == "string") {
                    APIerror = translateErrorMessages(
                        errors.detail,
                        "vulnerabilidad privada",
                    );
                } else {
                    formApiErrors = flatten422Errors(errors);
                }
                formData = {};
                formIsSubmitted = false;
                formApiErrors = {};
                APIerror = null;
                dispatch("save");
                showSubmit = true;
                return false;
            });
    }

    function handleCloseModal() {
        if (config.add) {
            formData = {};
            formData.references = [];
        }
        formIsSubmitted = false;
        formApiErrors = {};
        APIerror = null;

        // Call the parent modal close handler
        oncancel?.();
    }

    const handleKeydown = (event) => {
        if (event.key == "Escape") {
            handleCloseModal();
        }
    };

    const is_builder_disabled = () => {
        if (
            selected_cvss_items.AV.length &&
            selected_cvss_items.AC.length &&
            selected_cvss_items.PR.length &&
            selected_cvss_items.UI.length &&
            selected_cvss_items.C.length &&
            selected_cvss_items.I.length &&
            selected_cvss_items.A.length
        ) {
            is_builder_enabled.data = true;
            return false;
        } else {
            is_builder_enabled.data = false;
            return true;
        }
    };

    const buildCVSSobject = (data) => {
        Object.entries(data).forEach(([k, v]) => {
            if (v == "Red") v = "N";
            if (v == "Adyacente") v = "A";
            if (v == "Local") v = "L";
            if (v == "Físico") v = "P";
            if (v == "Requerida") v = "R";
            if (v == "Sin cambios") v = "U";
            if (v == "Alta" || v == "Alto") v = "H";
            if (v == "Baja" || v == "Bajo") v = "L";
            if (v == "Ninguno" || v == "Ninguna") v = "N";
            if (v == "Cambiado" || v == "Cambiada") v = "C";
            return (data[k] = v);
        });
        formData.cvss3_vector = vulnerabilityService.buildCVSSvector(data);
        formData.cvss3_vectorScore = customService.getCVSSscore(
            formData.cvss3_vector,
        );
        showCalculator = false;
        return formData.cvss3_vector;
    };

    run(() => {
        has_data = formData.cvss3_vector
            ? (selected_cvss_items = vulnerabilityService.parseCVSSvector(
                  formData,
                  3,
              ))
            : (has_data = false);
    });

    onMount(async () => {
        await tick();
        if (formData.hasOwnProperty("summary")) markdown_en = formData.summary;
        if (formData.hasOwnProperty("summary_es"))
            markdown_es = formData.summary_es;
    });

    $effect.pre(() => {
        if (markdown_es) {
            result_es.data = md.render(markdown_es);
        }
        if (markdown_en) {
            result_en.data = md.render(markdown_en);
        }
    });
</script>

<svelte:window onkeydown={handleKeydown} />

<form
    role="form"
    novalidate
    onsubmit={preventDefault(() => handleSubmit(config))}
>
    <div class="card">
        <div class="card-body">
            <div class="mb-3 input-half">
                <label for="title_es"
                    >{$format("list.columns.title")} ({$format(
                        "spanish",
                    )})</label
                >
                <input
                    type="text"
                    class="form-control"
                    id="customVulTitleEs"
                    name="title_es"
                    placeholder="Vulnerabilidad custom"
                    bind:value={formData.title_es}
                />
            </div>

            <div class="mb-3 input-half ms-4">
                <label for="title"
                    >{$format("list.columns.title")} ({$format(
                        "english",
                    )})</label
                >
                <input
                    type="text"
                    class="form-control"
                    id="customVulTitleEn"
                    name="title"
                    placeholder="Vulnerabilidad custom"
                    bind:value={formData.title}
                />
            </div>
            <div>
                <div class="markdown-editor__panel input-half mt-4">
                    <label class="markdown-editor__panel__label" for="desc_es"
                        >{$format("form.fields.description")} ({$format(
                            "spanish",
                        )})</label
                    >
                    <textarea
                        class="form-control"
                        id="customVulDescEs"
                        name="desc_es"
                        placeholder="{$format('insert')} Markdown"
                        style="height: 150px;"
                        bind:value={markdown_es}
                    ></textarea>
                </div>
                <div class="markdown-editor__panel input-half mt-4 ms-4">
                    <span class="markdown-editor__panel__label"
                        >{$format("preview")} ({$format(
                            "list.columns.description",
                        )}
                        {$format("spanish")})</span
                    >
                    <div
                        class="markdown-editor__result-html form-control"
                        style="height: 150px;"
                    >
                        {@html result_es.data || ""}
                    </div>
                </div>
            </div>

            <div>
                <div class="markdown-editor__panel input-half mt-4">
                    <label class="markdown-editor__panel__label" for="desc"
                        >{$format("form.fields.description")} ({$format(
                            "english",
                        )})</label
                    >
                    <textarea
                        class="form-control"
                        id="customVulDescEn"
                        name="desc"
                        placeholder="{$format('insert')} Markdown"
                        style="height: 150px;"
                        bind:value={markdown_en}
                    ></textarea>
                </div>
                <div class="markdown-editor__panel input-half mt-4 ms-4">
                    <span class="markdown-editor__panel__label"
                        >{$format("preview")} ({$format(
                            "list.columns.description",
                        )}
                        {$format("english")})</span
                    >
                    <div
                        class="markdown-editor__result-html form-control"
                        style="height: 150px; margin-bottom: 2em;"
                    >
                        {@html result_en.data || ""}
                    </div>
                </div>
            </div>
            <div class="cvss-calculator card input-half">
                <div>
                    <div
                        class="card-header cvss-calc-title"
                        class:isOpen={showCalculator}
                        style="cursor: pointer;"
                        onclick={() => (showCalculator = !showCalculator)}
                    >
                        <h4 class="card-title">
                            {$format("calc")}
                            {$format("vulnerability.cve_data.vector_cvss_3")}
                        </h4>
                    </div>
                    <div
                        class="card-body collapse"
                        class:show={showCalculator}
                        id="cvss-calculator"
                    >
                        <div class="d-flex justify-content-between">
                            <div class="mt-3">
                                <div>
                                    <strong
                                        >{$format(
                                            "vulnerability.cve_data.att_vector",
                                        )}</strong
                                    >
                                </div>
                                {#each CVSS_v3_items.attackVector().items as item}
                                    <div
                                        class="cveData-item"
                                        class:active={selected_cvss_items[
                                            "AV"
                                        ] == item.label}
                                        onclick={handlers(
                                            () =>
                                                (selected_cvss_items["AV"] =
                                                    item.label),
                                            is_builder_disabled,
                                        )}
                                    >
                                        {item.label}
                                    </div>
                                {/each}
                            </div>

                            <div class="mt-3">
                                <div>
                                    <strong
                                        >{$format(
                                            "vulnerability.cve_data.privs_required",
                                        )}</strong
                                    >
                                </div>
                                {#each CVSS_v3_items.privilegesRequired().items as item}
                                    <div
                                        class="cveData-item"
                                        class:active={selected_cvss_items[
                                            "PR"
                                        ] == item.label}
                                        onclick={handlers(
                                            () =>
                                                (selected_cvss_items["PR"] =
                                                    item.label),
                                            is_builder_disabled,
                                        )}
                                    >
                                        {item.label}
                                    </div>
                                {/each}
                            </div>
                        </div>

                        <div class="d-flex justify-content-between">
                            <div class="mt-3">
                                <div>
                                    <strong
                                        >{$format(
                                            "vulnerability.cve_data.complexity",
                                        )}</strong
                                    >
                                </div>
                                <div>
                                    <div class="t-vul-complexity">
                                        {#each CVSS_v3_items.attackComplexity().items as item}
                                            <div
                                                class="cveData-item"
                                                class:active={selected_cvss_items[
                                                    "AC"
                                                ] == item.label}
                                                onclick={handlers(
                                                    () =>
                                                        (selected_cvss_items[
                                                            "AC"
                                                        ] = item.label),
                                                    is_builder_disabled,
                                                )}
                                            >
                                                {item.label}
                                            </div>
                                        {/each}
                                    </div>
                                </div>
                            </div>

                            <div class="mt-3">
                                <div>
                                    <strong
                                        >{$format(
                                            "vulnerability.cve_data.user_interaction",
                                        )}</strong
                                    >
                                </div>
                                {#each CVSS_v3_items.userInteraction().items as item}
                                    <div
                                        class="cveData-item"
                                        class:active={selected_cvss_items[
                                            "UI"
                                        ] == item.label}
                                        onclick={handlers(
                                            () =>
                                                (selected_cvss_items["UI"] =
                                                    item.label),
                                            is_builder_disabled,
                                        )}
                                    >
                                        {item.label}
                                    </div>
                                {/each}
                            </div>
                        </div>

                        <div class="d-flex justify-content-between">
                            <div class="mt-3">
                                <div>
                                    <strong
                                        >{$format(
                                            "vulnerability.cve_data.scope",
                                        )}</strong
                                    >
                                </div>
                                {#each CVSS_v3_items.scope().items as item}
                                    <div
                                        class="cveData-item"
                                        class:active={selected_cvss_items[
                                            "S"
                                        ] == item.label}
                                        onclick={handlers(
                                            () =>
                                                (selected_cvss_items["S"] =
                                                    item.label),
                                            is_builder_disabled,
                                        )}
                                    >
                                        {item.label}
                                    </div>
                                {/each}
                            </div>
                        </div>

                        <div class="mt-3">
                            <div class="mb-3">
                                <strong style="font-size: 1.1em;"
                                    >{$format(
                                        "vulnerability.cve_data.impact",
                                    )}</strong
                                >
                            </div>
                            <div class="">
                                <div class="d-flex justify-content-between">
                                    <div>
                                        <div>
                                            <strong
                                                >{$format(
                                                    "vulnerability.cve_data.confidentiality",
                                                )}</strong
                                            >
                                        </div>
                                        {#each CVSS_v3_items.confidentialityImpact().items as item}
                                            <div
                                                class="cveData-item"
                                                class:active={selected_cvss_items[
                                                    "C"
                                                ] == item.label}
                                                onclick={handlers(
                                                    () =>
                                                        (selected_cvss_items[
                                                            "C"
                                                        ] = item.label),
                                                    is_builder_disabled,
                                                )}
                                            >
                                                {item.label}
                                            </div>
                                        {/each}
                                    </div>

                                    <div>
                                        <div class="">
                                            <strong
                                                >{$format(
                                                    "vulnerability.cve_data.integrity",
                                                )}</strong
                                            >
                                        </div>
                                        {#each CVSS_v3_items.integrityImpact().items as item}
                                            <div
                                                class="cveData-item"
                                                class:active={selected_cvss_items[
                                                    "I"
                                                ] == item.label}
                                                onclick={() => {
                                                    selected_cvss_items["I"] =
                                                        item.label;
                                                    is_builder_disabled();
                                                }}
                                            >
                                                {item.label}
                                            </div>
                                        {/each}
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <div>
                                        <div class="mt-3">
                                            <strong
                                                >{$format(
                                                    "vulnerability.cve_data.availability",
                                                )}</strong
                                            >
                                        </div>
                                        {#each CVSS_v3_items.availabilityImpact().items as item}
                                            <div
                                                class="cveData-item"
                                                class:active={selected_cvss_items[
                                                    "A"
                                                ] == item.label}
                                                onclick={() => {
                                                    selected_cvss_items["A"] =
                                                        item.label;
                                                    is_builder_disabled();
                                                }}
                                            >
                                                {item.label}
                                            </div>
                                        {/each}
                                    </div>
                                </div>
                                {#if formData.cvss3_vector}
                                    <div class="d-block mt-3">
                                        <strong>{$format("preview")}</strong>: {formData.cvss3_vector ||
                                            ""}
                                    </div>
                                {/if}
                                {#key is_builder_enabled.data}
                                    <button
                                        type="button"
                                        class="btn btn-primary mt-3"
                                        onclick={() =>
                                            buildCVSSobject(
                                                selected_cvss_items,
                                            )}
                                        disabled={!is_builder_enabled.data}
                                        >Generar vector</button
                                    >
                                {/key}

                                <button
                                    type="button"
                                    class="btn btn-default mt-3"
                                    onclick={() => {
                                        clearSelectedValues();
                                        is_builder_disabled();
                                    }}>{$format("clean")}</button
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mb-3 input-half ms-4">
                <label class="d-block" for="cvss_vector"
                    >{$format("vulnerability.cve_data.vector_cvss_3")}</label
                >
                <input
                    type="text"
                    class="form-control"
                    id="customVulVector"
                    name="cvss_vector"
                    placeholder="CVSS:3.1/AV:X/AC:X/PR:X/UI:X/S:X/C:X/I:X/A:X"
                    disabled={true}
                    style="height: 46.5px;"
                    bind:value={formData.cvss3_vector}
                />
            </div>

            <div
                class="mb-3 input-half"
                class:float-none={showCalculator}
                style="transition: all ease .5s; clear: both;"
            >
                <label class="d-block" for="cvss_vector"
                    >{$format("score_cvss")}</label
                >
                <input
                    type="text"
                    class="form-control"
                    id="customVulVector"
                    name="cvss_vector"
                    placeholder="0"
                    disabled={true}
                    style="height: 46.5px;"
                    bind:value={formData.cvss3_vectorScore}
                />
            </div>
            <div class="mb-3 input-half" class:ms-4={!showCalculator}>
                <label for="cwe_id">ID CWE</label>
                <input
                    type="text"
                    class="form-control"
                    style="min-height: 44px;"
                    id="customVulAddcwe_id"
                    name="cwe_id"
                    placeholder="CWE-xyz"
                    bind:value={formData.cwe_id}
                />
                {#if formData.cwe_id}<button
                        class="btn btn-default btn-validate-cwe"
                        class:btn-success={cwe}
                        class:btn-danger={cwe == "CWE no encontrado."}
                        onclick={preventDefault(showCWE)}
                        >Validar <i class="fas fa-check-circle"></i></button
                    >{/if}
                {#if cwe_not_validated_error}<div class="text-danger">
                        {cwe_not_validated_error}
                    </div>{/if}
                {#if cwe}
                    {#key loading_cwe}
                        {#if loading_cwe}<i class="fas fa-sync-alt fa-spin"
                            ></i>{/if}
                    {/key}
                    {#key cwe}
                        <div
                            class=""
                            style="border: 1px solid; padding: 1em 10px; margin-top: 15px;"
                        >
                            {#if cwe.id}
                                <div>{cwe.id}</div>
                                <div>
                                    <strong
                                        >{$format("form.fields.name")}</strong
                                    >: {cwe.name_es || cwe.name}
                                </div>
                                <div>
                                    <strong
                                        >{$format(
                                            "form.fields.description",
                                        )}</strong
                                    >: {cwe.description_es || cwe.description}
                                </div>
                            {:else}
                                <div class="text-danger">{cwe}</div>
                            {/if}
                        </div>
                    {/key}
                {/if}
            </div>
            <div class="mt-3">
                <References
                    references={references ? references : [""]}
                    addReference={addReferenceInput}
                    {pushReferences}
                    removeReference={removeReferenceInput}
                />
                {#if references_is_empty}
                    <div class="text-danger">
                        {$format("required")}
                    </div>
                {/if}
                {#if invalid_refs.length}
                    <div
                        class="mt-3"
                        style="clear: both; color: white; padding: 7px; border-radius: 4px; background: rgba(220, 53, 69, 0.88); max-width: 94%;"
                    >
                        {#if invalid_refs.length == 1}La siguiente URL es
                            inválida:{/if}
                        {#if invalid_refs.length >= 2}Las siguientes URLs son
                            inválidas:{/if}
                        <ul>
                            {#each invalid_refs as ref}
                                <li>{ref}</li>
                            {/each}
                        </ul>
                    </div>
                {/if}
            </div>
            <div class="card-footer">
                {#if showSubmit}
                    <button
                        id="customVulAddSubmit"
                        type="submit"
                        class="btn btn-primary"
                        >{$format("buttons.save")}</button
                    >
                    <button
                        class="btn btn-default"
                        type="button"
                        onclick={handleCloseModal}
                        data-bs-dismiss="modal"
                        >{$format("buttons.cancel")}</button
                    >
                {:else}
                    <div><i class="fas fa-sync-alt fa-spin"></i></div>
                {/if}
            </div>
        </div>
    </div>
</form>

<style>
    select {
        max-width: 400px;
    }
    .input-half {
        width: 48%;
        float: left;
    }
    .cveData-item {
        display: inline-block;
        margin: 3px;
        padding: 2px 5px;
        border: 0;
        cursor: pointer;
        font-size: 90%;
        border-radius: 5px;
        background: #f8f9fa;
        border: 1px solid #999999;
        border-radius: 5px;
        margin-left: 0;
    }
    .cveData-item:hover {
        background: #ccc;
    }
    .active {
        background: #666;
        color: white;
    }

    .cvss-calculator {
        margin-top: 2em;
        clear: left;
    }

    .cvss-calc-title.isOpen:before {
        transform: rotateX(180deg) rotateY(180deg);
    }

    .cvss-calc-title {
        position: relative;
        transition: transform 0.5s ease-in-out;
    }

    .cvss-calc-title:before {
        content: "\f107";
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
        position: absolute;
        bottom: 15px;
        right: 15px;
        transition: all 0.5s ease;
        color: #666;
    }

    .btn-validate-cwe {
        width: 100%;
        border-top: none;
        margin-top: -2px;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }

    .btn-validate-cwe:hover,
    .btn-validate-cwe.btn-success:hover,
    .btn-validate-cwe.btn-danger:hover {
        border: none;
    }

    .markdown-editor__panel__label {
        display: block;
        font-weight: 700;
        margin-bottom: 0.75rem;
    }

    .markdown-editor__result-html {
        box-sizing: inherit;
        height: 100%;
        width: 100%;
        padding: 1rem;
        overflow-y: scroll;
    }
</style>
